/**
 * @param {Object} options
 * @param {boolean} options.isMasterProductFlag
 * @param {boolean} options.isMemberOfMasterFlag
 * @param {boolean} options.isMemberProduct
 * @returns {'master' | 'member' | 'single item'}
 */
export const getProductType = ({ isMasterProductFlag = false, isMemberOfMasterFlag = false, isMemberProduct = false }) => {
  /** @type {'master' | 'member' | 'single item'} */
  let productType;
  switch (true) {
    case isMasterProductFlag || isMemberOfMasterFlag:
      productType = 'master';
      break;
    case isMemberProduct:
      productType = 'member';
      break;
    default:
      productType = 'single item';
  }
  return productType;
};
